<script>
import { list } from '@/api/cidade'

export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async autocomplete ({ searchValue, qtd, page }) {
      let result = await list({ cidade: searchValue, qtd, page })
      return result.data
    }
  }
}
</script>

<template>
  <ui-field-busca
    ref="fieldBusca"
    :model="model"
    field="cidade"
    width="1000"
    component="app-cidade-grid"
    label="Cidade"
    @change="v => $emit('change', v)" />
</template>
